<template>
  <div class="site-footer">
    {{copyright || '©2022 IMR Press.'}}
    <!-- © All copyright reserved by IMR Press 2022 -->
  </div>
</template>

<script>
export default {
  props: {
    copyright: {
      type: String,
      default: "©2022 IMR Press"
    }
  },

}
</script>

<style lang="scss" scoped>
.site-footer {
  background: $default_color;
  min-width: $sm_screen;
  color: $main_color;
  height: 40px;
  text-align: center;
  line-height: 40px;
  font-size: 12px;
}
</style>
